export class Contract {
    private _start: string | undefined
    private _end: string | undefined;

    public Start: string | undefined;
    public End: string | undefined;

    constructor(start?: string, end?: string) {
        this.SetValues(start, end);
    }

    public Reset() {
        this.SetValues(this._start, this._end);
    }

    get HasChanges() {
        return this.Start !== this._start
            || this.End !== this._end;
    }

    public SetValues(start?: string, end?: string){
        this._start = this.Start = !!start ? start.substr(0, 10) : undefined;
        this._end = this.End = !!end ? end.substr(0, 10) : undefined;
    }
}
